export const getUserRoles = (user) => {
  const storedRoles = Array.isArray(user?.roles) ? user.roles : [];
  return [...new Set([...storedRoles, user?.role].filter(Boolean))];
};

export const getBillingRole = (user) => (
  getUserRoles(user).includes('professional') ? 'professional' : 'client'
);